<template>
  <documents-component
    documents-name="Documents"
    :documents="documents" />
</template>

<script>
import DocumentsComponent from '../components/DocumentsComponent'

export default {
  data: () => ({
    documents: []
  }),
  components: {
    DocumentsComponent
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      // Get Documents
      vm.$http.get('documentsV2/' + vm.$store.state.Dbasename + '/documentsV2')
        .then(resp => {
          vm.documents = resp.data.reverse()
          vm.$store.commit('loading', false)
        })
    })
  },

  mounted () {
    this.$store.dispatch('logReadItems')
  }
}
</script>
